import { RootState } from 'types';

export const selectCoachId = (state: RootState) => state?.manageCoach?.coachId!;
export const selectInsuranceUpload = (state: RootState) =>
  state?.manageCoach?.insuranceUpload;
